import { FC, ReactNode } from 'react';
import styles from './entry-page-routes-wrapper.module.scss';
import { SecondaryNavigation } from '@app/shared/components/secondary-navigation/SecondaryNavigation';
import { NavigationItem } from '@app/shared/components/secondary-navigation/secondary-navigation-types';
import classNames from 'classnames';
import { useLocale } from '@app/core/hooks/useLocale';
const PARENT_CLASSNAME = 'entry-page-routes-wrapper';

type EntryPageRoutesWrapperProps = {
  children: ReactNode;
  actions?: ReactNode;
};

const EntryPageRoutesWrapper: FC<EntryPageRoutesWrapperProps> = ({
  children,
  actions,
}): JSX.Element => {
  const { l } = useLocale();
  document.title = 'Equity Reward Analytics';
  const navigationItems: NavigationItem[] = [
    {
      label: 'Projects',
      route: '../projects',
    },
  ];

  return (
    <>
      <div className={styles[PARENT_CLASSNAME]}>
        <div className={styles[`${PARENT_CLASSNAME}__header`]}>
          <div
            className={classNames([
              styles[`${PARENT_CLASSNAME}__content`],
              styles[`${PARENT_CLASSNAME}__content--header`],
            ])}>
            {navigationItems.length > 1 ? (
              <SecondaryNavigation navigationItems={navigationItems} />
            ) : (
              <h1 className={styles[`${PARENT_CLASSNAME}__title`]}>{l('_AllProjects')}</h1>
            )}
            {actions && <div className={styles[`${PARENT_CLASSNAME}__actions`]}>{actions}</div>}
          </div>
        </div>
        <div className={styles[`${PARENT_CLASSNAME}__content`]}>{children}</div>
      </div>
    </>
  );
};

export default EntryPageRoutesWrapper;
